/* Liquid Gold Ops — Kino Clinic
   All runtime behavior lives under `window.LiquidGold.kino.*`.
   Boot dispatcher at the bottom wires each module on DOMContentLoaded. */

(function () {
  'use strict';

  window.LiquidGold = window.LiquidGold || {};
  window.LiquidGold.kino = window.LiquidGold.kino || {};
  var ns = window.LiquidGold.kino;

  ns.nav = {
    init: function () {
      var header = document.querySelector('header-component');
      if (!header) return;
      var threshold = 40;
      var update = function () {
        if (window.scrollY > threshold) {
          header.classList.add('is-lg-scrolled');
        } else {
          header.classList.remove('is-lg-scrolled');
        }
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    },
  };

  // Mobile menu: reuse Horizon's native drawer — no-op placeholder.
  ns.mobileMenu = {
    init: function () {},
  };

  ns.countUp = {
    init: function () {
      var els = document.querySelectorAll('[data-lg-count]');
      if (!els.length) return;

      var format = function (el, value) {
        var raw = el.dataset.lgCount || '';
        var decimals = raw.indexOf('.') !== -1 ? 1 : 0;
        el.textContent = value.toFixed(decimals);
      };

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || typeof IntersectionObserver === 'undefined') {
        els.forEach(function (el) {
          var target = parseFloat(el.dataset.lgCount);
          if (!isNaN(target)) format(el, target);
        });
        return;
      }

      var easeOut = function (t) {
        return 1 - Math.pow(1 - t, 3);
      };

      var animate = function (el) {
        if (el.dataset.lgCounted) return;
        el.dataset.lgCounted = '1';
        var target = parseFloat(el.dataset.lgCount);
        if (isNaN(target)) return;
        var duration = 1200;
        var start = null;
        var tick = function (ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          format(el, target * easeOut(progress));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animate(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -15% 0px' }
      );

      els.forEach(function (el) {
        observer.observe(el);
      });
    },
  };

  ns.ctaFinal = {
    init: function () {
      var containers = document.querySelectorAll('.lg-kino-cta-final');
      if (!containers.length) return;

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      containers.forEach(function (container) {
        var lines = container.querySelectorAll('.lg-kino-cta-final__line');
        var labels = container.querySelectorAll('.lg-kino-cta-final__media-label');
        if (!lines.length) return;

        var setActive = function (index) {
          lines.forEach(function (line, i) {
            line.classList.toggle('is-on', i === index);
          });
          var activeLine = lines[index];
          if (!activeLine) return;
          var activeLabel = activeLine.getAttribute('data-label') || '';
          labels.forEach(function (label) {
            label.classList.toggle(
              'is-on',
              label.getAttribute('data-label') === activeLabel
            );
          });
        };

        if (reduced) {
          lines.forEach(function (line) {
            line.classList.add('is-on');
          });
          labels.forEach(function (label) {
            label.classList.add('is-on');
          });
          return;
        }

        var index = 0;
        var timer = null;
        var tick = function () {
          index = (index + 1) % lines.length;
          setActive(index);
        };

        setActive(0);

        if (typeof IntersectionObserver === 'undefined') {
          timer = setInterval(tick, 2400);
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!timer) timer = setInterval(tick, 2400);
              } else if (timer) {
                clearInterval(timer);
                timer = null;
              }
            });
          },
          { threshold: 0.35 }
        );
        observer.observe(container);
      });
    },
  };

  ns.modals = {
    init: function () {
      var focusableSelector =
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      var lastFocus = null;
      var openModal = null;

      var getFocusables = function (root) {
        return Array.prototype.slice
          .call(root.querySelectorAll(focusableSelector))
          .filter(function (el) {
            return !el.hasAttribute('disabled') && el.offsetParent !== null;
          });
      };

      var trapFocus = function (e) {
        if (!openModal) return;
        var dialog = openModal.querySelector('.lg-kino-modal__dialog');
        if (!dialog) return;
        var items = getFocusables(dialog);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      var close = function (modal) {
        if (!modal) return;
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('lg-kino-modal-open');
        var dialog = modal.querySelector('.lg-kino-modal__dialog');
        var finish = function () {
          modal.hidden = true;
          if (dialog) dialog.removeEventListener('transitionend', finish);
        };
        if (dialog) {
          dialog.addEventListener('transitionend', finish);
          // Fallback in case transitionend never fires (reduced-motion, etc.)
          setTimeout(finish, 400);
        } else {
          finish();
        }
        if (modal === openModal) {
          openModal = null;
          if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus();
          }
        }
      };

      var open = function (modal) {
        if (!modal || openModal === modal) return;
        if (openModal) close(openModal);
        lastFocus = document.activeElement;
        modal.hidden = false;
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        document.documentElement.classList.add('lg-kino-modal-open');
        openModal = modal;
        var dialog = modal.querySelector('.lg-kino-modal__dialog');
        if (dialog) {
          var firstFocusable = getFocusables(dialog)[0];
          if (firstFocusable) firstFocusable.focus();
        }
      };

      document.addEventListener('keydown', function (e) {
        // Activate non-native triggers (e.g. role="button" elements) via Enter/Space.
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          var target = e.target;
          if (
            target &&
            target.matches &&
            target.matches('[data-lg-open-protocol]') &&
            target.tagName !== 'BUTTON' &&
            target.tagName !== 'A'
          ) {
            e.preventDefault();
            var protocolModal = document.getElementById('lg-kino-modal-protocol');
            if (protocolModal) open(protocolModal);
            return;
          }
        }

        if (!openModal) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          close(openModal);
        } else if (e.key === 'Tab') {
          trapFocus(e);
        }
      });

      document.addEventListener('click', function (e) {
        var openTrigger = e.target.closest('[data-lg-open-protocol]');
        if (openTrigger) {
          e.preventDefault();
          var protocolModal = document.getElementById('lg-kino-modal-protocol');
          if (protocolModal) open(protocolModal);
          return;
        }

        var closeTrigger = e.target.closest('[data-lg-modal-close]');
        if (closeTrigger) {
          e.preventDefault();
          var modalRoot = closeTrigger.closest('.lg-kino-modal') || openModal;
          if (modalRoot) close(modalRoot);
        }
      });

      var protocolModal = document.getElementById('lg-kino-modal-protocol');
      if (protocolModal) {
        var items = protocolModal.querySelectorAll('[data-lg-protocol-value]');
        var continueEl = protocolModal.querySelector('[data-lg-protocol-continue]');

        var setActive = function (target) {
          if (target.classList.contains('is-disabled')) return;
          items.forEach(function (item) {
            var isActive = item === target;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            item.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });
          if (continueEl) {
            var href = target.getAttribute('data-lg-href') || '#';
            continueEl.setAttribute('href', href);
          }
        };

        items.forEach(function (item) {
          item.addEventListener('click', function () {
            setActive(item);
          });
          item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setActive(item);
            }
          });
        });
      }

      var legalModal = document.getElementById('lg-kino-modal-legal');
      if (legalModal) {
        var tabs = legalModal.querySelectorAll('[role="tab"]');
        var panels = legalModal.querySelectorAll('[role="tabpanel"]');

        var selectTab = function (key) {
          tabs.forEach(function (tab) {
            var isSelected = tab.getAttribute('data-lg-tab') === key;
            tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            tab.tabIndex = isSelected ? 0 : -1;
          });
          panels.forEach(function (panel) {
            panel.classList.toggle(
              'is-active',
              panel.getAttribute('data-lg-panel') === key
            );
          });
        };

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-lg-tab');
            if (key) selectTab(key);
          });
        });

        document.addEventListener('click', function (e) {
          var link = e.target.closest('a');
          if (!link) return;
          var key = link.getAttribute('data-legal');
          if (!key) {
            var href = link.getAttribute('href') || '';
            var m = href.match(/^#legal-(privacy|terms|disclosures)$/);
            if (m) key = m[1];
          }
          if (!key) return;
          e.preventDefault();
          selectTab(key);
          open(legalModal);
        });
      }
    },
  };

  function boot() {
    ns.nav.init();
    ns.mobileMenu.init();
    ns.countUp.init();
    ns.ctaFinal.init();
    ns.modals.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
